/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
/*!********************************!*\
  !*** ./src/assets/js/theme.js ***!
  \********************************/
(function () {
  document.addEventListener('toggle-dropdown-disclosure', function () {
    var element = document.querySelector('.header__resize');
    element.classList.toggle('header__resize--open');
    if (!element.classList.contains('header__resize--open')) {
      var megamenus = document.querySelectorAll('.product-grid-list');
      if (megamenus) {
        megamenus.forEach(function (menu) {
          menu.style.display = 'none';
        });
      }
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    initMobileDropdownMenu();
    initImageAnimationScroll();
    initCustomMegaMenu();
    // if url contains /cart, redirect to /collections/all
    if (window.location.pathname.includes('/cart')) {
      window.location.replace('/collections/all');
    }
    document.addEventListener("dialog:after-hide", function () {
      document.querySelector('.native-share--disabled').classList.remove('lock');
    });

    /* // Function to move the element
     function moveSellingPlanGroupOptions() {
         let targetElement = document.querySelector('.sealsubs-target-element');
         let container = document.querySelector('.sealsubs-container');
         let sellingPlanGroupOptions = document.querySelector('.sls-selling-plan-group-options');
         let purchaseOptionsContainer = document.querySelector('.sls-purchase-options-container');
         let radioButtons = document.querySelectorAll('.sls-option-container');
          if (targetElement && sellingPlanGroupOptions && purchaseOptionsContainer && container) {
             container.appendChild(sellingPlanGroupOptions);
             radioButtons.forEach(function(radioButton) {
                 radioButton.addEventListener('click', toggleSellingPlanGroupOptions);
                 if (radioButton.classList.contains('sls-active') && radioButton.getAttribute('data-selling-plan-group') !== null) {
                     sellingPlanGroupOptions.style.display = 'block';
                     let select = sellingPlanGroupOptions.querySelector('select');
                     let sellingPlanInput = document.querySelector('input[name="selling_plan"][data-sls-selling_plan]');
                     if (select && sellingPlanInput) {
                         console.log('inside if', select.options[0].value);
                         sellingPlanInput.value = select.options[0].value;
                     }
                 }
             });
             return true; // Successfully moved the element
         }
         return false; // Elements not found yet
     }
      function toggleSellingPlanGroupOptions(event) {
         let sellingPlanGroupOptions = document.querySelector('.sls-selling-plan-group-options');
         let clickedOptionContainer = event ? event.currentTarget : null;
          if (clickedOptionContainer && clickedOptionContainer.getAttribute('data-selling-plan-group') !== null) {
             sellingPlanGroupOptions.style.display = 'block';
             let select = sellingPlanGroupOptions.querySelector('select');
             let sellingPlanInput = document.querySelector('input[name="selling_plan"]');
             if (select && sellingPlanInput) {
                 sellingPlanInput.value = select.options[0].value;
             }
         } else {
             sellingPlanGroupOptions.style.display = 'none';
         }
     }
      if (!moveSellingPlanGroupOptions()) {
         let observer = new MutationObserver(function(mutations) {
             mutations.forEach(function(mutation) {
                 if (moveSellingPlanGroupOptions()) {
                     observer.disconnect(); // Stop observing once the elements are moved
                 }
             });
         });
         observer.observe(document.body, { childList: true, subtree: true });
     }*/
  });
  function initMobileDropdownMenu() {
    var openButton = document.querySelector('[data-open-dropdown-mobile-menu]');
    var closeButton = document.querySelector('[data-close-dropdown-mobile-menu]');
    var wrapper = document.querySelector('store-header');
    var cards = document.querySelectorAll('store-header .product-card');
    if (openButton) {
      openButton.addEventListener('click', function () {
        wrapper.classList.add('header__resize-mobile--open');
        openButton.style.display = 'none';
        closeButton.style.display = 'block';
        document.documentElement.style.overflow = 'hidden';
      });
    }
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        wrapper.classList.remove('header__resize-mobile--open');
        closeButton.style.display = 'none';
        openButton.style.display = 'block';
        document.documentElement.style.overflow = 'auto';
      });
    }

    // Close mobile menu when clicking hash links
    var mobileMenuLinks = document.querySelectorAll('.mobile-dropdown-menu a[href^="#"]');
    mobileMenuLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        if (wrapper && wrapper.classList.contains('header__resize-mobile--open')) {
          // Close menu
          wrapper.classList.remove('header__resize-mobile--open');
          if (closeButton) closeButton.style.display = 'none';
          if (openButton) openButton.style.display = 'block';
          document.documentElement.style.overflow = 'auto';
        }
      });
    });
  }
  var MAX_PARENT_CHECK = 10;
  function getScaleParent(element) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (count >= MAX_PARENT_CHECK) {
      return null;
    }
    var parent = element === null || element === void 0 ? void 0 : element.parentElement;
    if (parent && !parent.hasAttribute('data-scale-on-scroll')) {
      return getScaleParent(parent, count + 1);
    }
    return parent;
  }
  function initImageAnimationScroll() {
    var images = document.querySelectorAll('[data-scale-on-scroll] img');
    var startScale = 2; // Start with a larger scale
    var endScale = 1; // Scale down to original size

    if (images && images.length > 0) {
      images.forEach(function (image) {
        var imageWrapper = image.parentElement;
        if (imageWrapper) {
          imageWrapper.style.overflow = 'hidden';
        }
        if (image) {
          image.style.transition = 'transform linear 0s'; // Immediate response to scroll
          image.style.transform = "scale(".concat(startScale, ")"); // Set initial scale
        }
        window.addEventListener('scroll', function () {
          var rect = image.getBoundingClientRect();
          var windowHeight = window.innerHeight;
          var imageHeight = rect.height;

          // Check if the image is visible in the viewport
          var isVisible = rect.bottom > 0 && rect.top < windowHeight;
          if (isVisible) {
            // Calculate how much of the image has moved through the viewport
            var scrollProgress = (windowHeight - rect.top) / (windowHeight + imageHeight);

            // Scale based on scroll progress
            var scale = startScale - scrollProgress * (startScale - endScale);

            // Ensure scale stays within defined limits
            scale = Math.max(Math.min(scale, startScale), endScale);

            // Apply the calculated scale
            image.style.transform = "scale(".concat(scale, ")");
          }
        });
      });
    }
  }
  function updateMenuDisplay(menuValue) {
    var targetMenu = document.querySelector("[data-custom-megamenu=\"".concat(menuValue, "\"]"));
    if (targetMenu) {
      if (getComputedStyle(targetMenu).display === "none") {
        targetMenu.style.display = "flex";
      }
      var element = document.querySelector('.header__resize');
      if (!element.classList.contains('header__resize--open')) {
        targetMenu.style.display = 'none';
      }
    }
  }
  function initCustomMegaMenu() {
    var menuItems = document.querySelectorAll("[data-trigger-custom-megamenu]");
    menuItems.forEach(function (item) {
      item.addEventListener("click", function () {
        var menuValue = item.getAttribute("data-trigger-custom-megamenu");
        updateMenuDisplay(menuValue);
      });
    });
  }
  var scrollToTopBtn = document.getElementById('scrollToTopBtn');
  var rootElement = document.documentElement;
  //scroll to top function
  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', scrollToTop);
  }

  // Get the current URL path
  var currentPath = window.location.pathname;
  // Check if the current path contains '/collections/'
  if (currentPath.startsWith('/collections/') && currentPath !== '/collections/all') {
    if (currentPath.includes('b2b')) {
      if (currentPath !== '/collections/b2b') {
        // Extract the collection name from the path
        var collectionName = currentPath.replace('/collections/', '').replace(/\/$/, '');
        // Redirect to the /collections/all page with the corresponding anchor
        window.location.href = '/collections/b2b#nav-' + collectionName;
      }
    } else {
      // Extract the collection name from the path
      var collectionName = currentPath.replace('/collections/', '').replace(/\/$/, '');
      // Redirect to the /collections/all page with the corresponding anchor
      window.location.href = '/collections/all#nav-' + collectionName;
    }
  }
})();
})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
/*!*******************************************!*\
  !*** ./src/assets/js/b2b-subscription.js ***!
  \*******************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var B2BSubscriptionChoose = /*#__PURE__*/function (_HTMLElement) {
  function B2BSubscriptionChoose() {
    var _this;
    _classCallCheck(this, B2BSubscriptionChoose);
    _this = _callSuper(this, B2BSubscriptionChoose);
    _this.debug = false;
    _this.oneTimeInput = _this.querySelector('.one-time');
    _this.subscriptionInput = _this.querySelector('.subscription');
    _this.frequencySelect = _this.querySelector('.subscription_frequency');
    _this.debounceTimer = null;
    _this.stickyCart = document.querySelector('sticky-cart');
    _this.drawerCart = document.querySelector('cart-drawer');
    return _this;
  }
  _inherits(B2BSubscriptionChoose, _HTMLElement);
  return _createClass(B2BSubscriptionChoose, [{
    key: "log",
    value: function log() {
      if (this.debug) {
        var _console;
        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.log('B2BSubscriptionChoose connected');
      this.init();
      document.addEventListener('cart:update', this.handleExternalCartUpdate.bind(this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('cart:update', this.handleExternalCartUpdate.bind(this));
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.log('Initializing B2BSubscriptionChoose');
              _context.next = 3;
              return this.fetchCartData();
            case 3:
              this.addEventListeners();
              this.setInitialState();
              this.classList.remove('loading');
              this.log('Initialization complete');
              _context.next = 9;
              return this.checkAndUpdateNewItems();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "checkAndUpdateNewItems",
    value: function () {
      var _checkAndUpdateNewItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var subscriptionMode, subscriptionFrequency;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.log('Checking for new items in the cart');
              subscriptionMode = this.cartData.attributes['subscription_mode'];
              subscriptionFrequency = this.cartData.attributes['subscription_frequency'];
              if (!(subscriptionMode === 'subscription')) {
                _context2.next = 8;
                break;
              }
              _context2.next = 6;
              return this.updateAllProductsToSubscription(subscriptionFrequency);
            case 6:
              _context2.next = 10;
              break;
            case 8:
              _context2.next = 10;
              return this.updateAllProductsToOneTime();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function checkAndUpdateNewItems() {
        return _checkAndUpdateNewItems.apply(this, arguments);
      }
      return checkAndUpdateNewItems;
    }()
  }, {
    key: "refreshCart",
    value: function refreshCart() {
      var _this2 = this;
      fetch(window.location.href).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        if (_this2.stickyCart) {
          _this2.stickyCart.innerHTML = doc.querySelector('sticky-cart').innerHTML;
          _this2.redefineStickyCart(); // Reinitialize the sticky cart
        }
        if (_this2.drawerCart) {
          _this2.drawerCart.innerHTML = doc.querySelector('cart-drawer').innerHTML;
        }
      })["catch"](function (err) {
        _this2.log('Something went wrong.', err);
      });
    }
  }, {
    key: "redefineStickyCart",
    value: function redefineStickyCart() {
      var stickyCartElement = document.querySelector('sticky-cart');
      if (stickyCartElement) {
        // Remove the current sticky-cart element
        var parent = stickyCartElement.parentNode;
        var newStickyCart = stickyCartElement.cloneNode(true);
        parent.replaceChild(newStickyCart, stickyCartElement);

        // Re-define the custom element
        if (!customElements.get('sticky-cart')) {
          customElements.define('sticky-cart', StickyCart); // Reinitialize the StickyCart class
        }
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this3 = this;
      this.log('Adding event listeners');
      this.oneTimeInput.addEventListener('change', function () {
        return _this3.handleModeChange('one-time');
      });
      this.subscriptionInput.addEventListener('change', function () {
        return _this3.handleModeChange('subscription');
      });
      this.frequencySelect.addEventListener('change', this.handleFrequencyChange.bind(this));
    }
  }, {
    key: "fetchCartData",
    value: function () {
      var _fetchCartData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.log('Fetching cart data');
              _context3.next = 3;
              return fetch('/cart.js');
            case 3:
              response = _context3.sent;
              _context3.next = 6;
              return response.json();
            case 6:
              this.cartData = _context3.sent;
              this.log('Cart data fetched:', this.cartData);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchCartData() {
        return _fetchCartData.apply(this, arguments);
      }
      return fetchCartData;
    }()
  }, {
    key: "setInitialState",
    value: function setInitialState() {
      this.log('Setting initial state');
      var subscriptionMode = this.cartData.attributes['subscription_mode'];
      var subscriptionFrequency = this.cartData.attributes['subscription_frequency'];
      this.log('Current subscription mode:', subscriptionMode);
      this.log('Current subscription frequency:', subscriptionFrequency);
      if (subscriptionMode === 'subscription') {
        this.subscriptionInput.checked = true;
        this.frequencySelect.value = subscriptionFrequency || '';
        this.frequencySelect.disabled = false;
      } else {
        this.oneTimeInput.checked = true;
        this.frequencySelect.disabled = true;
      }
    }
  }, {
    key: "handleModeChange",
    value: function () {
      var _handleModeChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(mode) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.log('Mode change triggered:', mode);
              this.classList.add('loading');
              _context4.prev = 2;
              if (!(mode === 'subscription')) {
                _context4.next = 8;
                break;
              }
              _context4.next = 6;
              return this.setSubscriptionMode();
            case 6:
              _context4.next = 10;
              break;
            case 8:
              _context4.next = 10;
              return this.setOneTimeMode();
            case 10:
              this.dispatchCartUpdate();
              _context4.next = 16;
              break;
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](2);
              this.log('Error changing mode:', _context4.t0);
            case 16:
              _context4.prev = 16;
              this.classList.remove('loading');
              return _context4.finish(16);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 13, 16, 19]]);
      }));
      function handleModeChange(_x) {
        return _handleModeChange.apply(this, arguments);
      }
      return handleModeChange;
    }()
  }, {
    key: "setSubscriptionMode",
    value: function () {
      var _setSubscriptionMode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var frequency;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.log('Setting subscription mode');
              frequency = this.frequencySelect.value;
              this.log('Selected frequency:', frequency);
              _context5.next = 5;
              return this.updateCartAttributes({
                subscription_mode: 'subscription',
                subscription_frequency: frequency
              });
            case 5:
              this.frequencySelect.disabled = false;
              _context5.next = 8;
              return this.updateAllProductsToSubscription(frequency);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setSubscriptionMode() {
        return _setSubscriptionMode.apply(this, arguments);
      }
      return setSubscriptionMode;
    }()
  }, {
    key: "setOneTimeMode",
    value: function () {
      var _setOneTimeMode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.log('Setting one-time mode');
              _context6.next = 3;
              return this.updateCartAttributes({
                subscription_mode: 'one-time',
                subscription_frequency: ''
              });
            case 3:
              this.frequencySelect.disabled = true;
              _context6.next = 6;
              return this.updateAllProductsToOneTime();
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setOneTimeMode() {
        return _setOneTimeMode.apply(this, arguments);
      }
      return setOneTimeMode;
    }()
  }, {
    key: "handleFrequencyChange",
    value: function () {
      var _handleFrequencyChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this.log('Frequency change triggered');
              clearTimeout(this.debounceTimer);
              this.debounceTimer = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                var frequency;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      frequency = _this4.frequencySelect.value;
                      _this4.log('New frequency selected:', frequency);
                      _this4.classList.add('loading');
                      _context7.prev = 3;
                      _context7.next = 6;
                      return _this4.updateCartAttributes({
                        subscription_frequency: frequency
                      });
                    case 6:
                      _context7.next = 8;
                      return _this4.updateAllProductsToSubscription(frequency);
                    case 8:
                      _this4.dispatchCartUpdate();
                      _context7.next = 14;
                      break;
                    case 11:
                      _context7.prev = 11;
                      _context7.t0 = _context7["catch"](3);
                      _this4.log('Error changing frequency:', _context7.t0);
                    case 14:
                      _context7.prev = 14;
                      _this4.classList.remove('loading');
                      return _context7.finish(14);
                    case 17:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7, null, [[3, 11, 14, 17]]);
              })), 300);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function handleFrequencyChange() {
        return _handleFrequencyChange.apply(this, arguments);
      }
      return handleFrequencyChange;
    }()
  }, {
    key: "updateAllProductsToSubscription",
    value: function () {
      var _updateAllProductsToSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(frequency) {
        var _this5 = this;
        var items, cartUpdated, _iterator, _step, _loop;
        return _regeneratorRuntime().wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.log('Updating all products to subscription with frequency:', frequency);
              _context10.next = 3;
              return this.fetchSellingPlans();
            case 3:
              items = _context10.sent;
              this.log('Fetched selling plans:', items);
              cartUpdated = false;
              _iterator = _createForOfIteratorHelper(this.cartData.items);
              _context10.prev = 7;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var item, itemData, plan, _item$selling_plan_al;
                return _regeneratorRuntime().wrap(function _loop$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      item = _step.value;
                      _this5.log('Processing item:', item);
                      itemData = items.find(function (i) {
                        return i.variant_id.toString() === item.variant_id.toString();
                      });
                      if (!(itemData && itemData.selling_plan_info && itemData.selling_plan_info.length > 0)) {
                        _context9.next = 16;
                        break;
                      }
                      plan = itemData.selling_plan_info[0].selling_plans.find(function (p) {
                        return p.name === frequency;
                      });
                      if (!plan) {
                        _context9.next = 13;
                        break;
                      }
                      _this5.log('Matching plan found:', plan);
                      if (!(((_item$selling_plan_al = item.selling_plan_allocation) === null || _item$selling_plan_al === void 0 ? void 0 : _item$selling_plan_al.selling_plan.id.toString()) !== plan.id.toString())) {
                        _context9.next = 11;
                        break;
                      }
                      _context9.next = 10;
                      return _this5.updateCartItem(item.key, item.quantity, plan.id.toString());
                    case 10:
                      cartUpdated = true;
                    case 11:
                      _context9.next = 14;
                      break;
                    case 13:
                      _this5.log('No matching plan found for item:', item);
                    case 14:
                      _context9.next = 17;
                      break;
                    case 16:
                      _this5.log('No selling plan info found for item:', item);
                    case 17:
                    case "end":
                      return _context9.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 10:
              if ((_step = _iterator.n()).done) {
                _context10.next = 14;
                break;
              }
              return _context10.delegateYield(_loop(), "t0", 12);
            case 12:
              _context10.next = 10;
              break;
            case 14:
              _context10.next = 19;
              break;
            case 16:
              _context10.prev = 16;
              _context10.t1 = _context10["catch"](7);
              _iterator.e(_context10.t1);
            case 19:
              _context10.prev = 19;
              _iterator.f();
              return _context10.finish(19);
            case 22:
              if (!cartUpdated) {
                _context10.next = 26;
                break;
              }
              _context10.next = 25;
              return this.fetchCartData();
            case 25:
              this.refreshCart();
            case 26:
            case "end":
              return _context10.stop();
          }
        }, _callee9, this, [[7, 16, 19, 22]]);
      }));
      function updateAllProductsToSubscription(_x2) {
        return _updateAllProductsToSubscription.apply(this, arguments);
      }
      return updateAllProductsToSubscription;
    }()
  }, {
    key: "updateAllProductsToOneTime",
    value: function () {
      var _updateAllProductsToOneTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var cartUpdated, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.log('Updating all products to one-time');
              cartUpdated = false;
              _iterator2 = _createForOfIteratorHelper(this.cartData.items);
              _context11.prev = 3;
              _iterator2.s();
            case 5:
              if ((_step2 = _iterator2.n()).done) {
                _context11.next = 13;
                break;
              }
              item = _step2.value;
              if (!item.selling_plan_allocation) {
                _context11.next = 11;
                break;
              }
              _context11.next = 10;
              return this.updateCartItem(item.key, item.quantity, '');
            case 10:
              cartUpdated = true;
            case 11:
              _context11.next = 5;
              break;
            case 13:
              _context11.next = 18;
              break;
            case 15:
              _context11.prev = 15;
              _context11.t0 = _context11["catch"](3);
              _iterator2.e(_context11.t0);
            case 18:
              _context11.prev = 18;
              _iterator2.f();
              return _context11.finish(18);
            case 21:
              if (!cartUpdated) {
                _context11.next = 25;
                break;
              }
              _context11.next = 24;
              return this.fetchCartData();
            case 24:
              this.refreshCart();
            case 25:
            case "end":
              return _context11.stop();
          }
        }, _callee10, this, [[3, 15, 18, 21]]);
      }));
      function updateAllProductsToOneTime() {
        return _updateAllProductsToOneTime.apply(this, arguments);
      }
      return updateAllProductsToOneTime;
    }()
  }, {
    key: "updateCartItem",
    value: function () {
      var _updateCartItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(key, quantity, sellingPlanId) {
        var data, response, result;
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              this.log("Updating cart item: key=".concat(key, ", quantity=").concat(quantity, ", sellingPlanId=").concat(sellingPlanId));
              data = {
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanId
              };
              _context12.prev = 2;
              _context12.next = 5;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              });
            case 5:
              response = _context12.sent;
              if (response.ok) {
                _context12.next = 8;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 8:
              _context12.next = 10;
              return response.json();
            case 10:
              result = _context12.sent;
              this.log('Cart item update result:', result);
              _context12.next = 17;
              break;
            case 14:
              _context12.prev = 14;
              _context12.t0 = _context12["catch"](2);
              this.log('Error updating cart item:', _context12.t0);
            case 17:
            case "end":
              return _context12.stop();
          }
        }, _callee11, this, [[2, 14]]);
      }));
      function updateCartItem(_x3, _x4, _x5) {
        return _updateCartItem.apply(this, arguments);
      }
      return updateCartItem;
    }()
  }, {
    key: "updateCartAttributes",
    value: function () {
      var _updateCartAttributes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(attributes) {
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              this.log('Updating cart attributes:', attributes);
              _context13.next = 3;
              return this.updateCart({
                attributes: attributes
              });
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee12, this);
      }));
      function updateCartAttributes(_x6) {
        return _updateCartAttributes.apply(this, arguments);
      }
      return updateCartAttributes;
    }()
  }, {
    key: "updateCart",
    value: function () {
      var _updateCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(data) {
        var response, result;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              this.log('Updating cart with data:', data);
              _context14.prev = 1;
              _context14.next = 4;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              });
            case 4:
              response = _context14.sent;
              if (response.ok) {
                _context14.next = 7;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 7:
              _context14.next = 9;
              return response.json();
            case 9:
              result = _context14.sent;
              this.log('Cart update result:', result);
              this.cartData = result;
              this.dispatchEvent(new CustomEvent('cart:updated', {
                bubbles: true,
                detail: result
              }));
              _context14.next = 18;
              break;
            case 15:
              _context14.prev = 15;
              _context14.t0 = _context14["catch"](1);
              this.log('Error updating cart:', _context14.t0);
            case 18:
            case "end":
              return _context14.stop();
          }
        }, _callee13, this, [[1, 15]]);
      }));
      function updateCart(_x7) {
        return _updateCart.apply(this, arguments);
      }
      return updateCart;
    }()
  }, {
    key: "fetchSellingPlans",
    value: function () {
      var _fetchSellingPlans = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var response, text, parser, doc, settingsElement, sellingPlans;
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              this.log('Fetching selling plans');
              _context15.prev = 1;
              _context15.next = 4;
              return fetch('/cart?view=b2b-ajax');
            case 4:
              response = _context15.sent;
              _context15.next = 7;
              return response.text();
            case 7:
              text = _context15.sent;
              parser = new DOMParser();
              doc = parser.parseFromString(text, 'text/html');
              settingsElement = doc.querySelector('[data-cart-settings]');
              if (!settingsElement) {
                _context15.next = 15;
                break;
              }
              sellingPlans = JSON.parse(settingsElement.textContent).items;
              this.log('Fetched selling plans:', sellingPlans);
              return _context15.abrupt("return", sellingPlans);
            case 15:
              _context15.next = 20;
              break;
            case 17:
              _context15.prev = 17;
              _context15.t0 = _context15["catch"](1);
              this.log('Error fetching selling plans:', _context15.t0);
            case 20:
              return _context15.abrupt("return", []);
            case 21:
            case "end":
              return _context15.stop();
          }
        }, _callee14, this, [[1, 17]]);
      }));
      function fetchSellingPlans() {
        return _fetchSellingPlans.apply(this, arguments);
      }
      return fetchSellingPlans;
    }()
  }, {
    key: "dispatchCartUpdate",
    value: function dispatchCartUpdate() {
      this.log('Dispatching cart update event');
      var event = new CustomEvent('cart:update', {
        detail: {
          cartData: this.cartData
        },
        bubbles: true,
        composed: true
      });
      document.dispatchEvent(event);
    }
  }, {
    key: "handleExternalCartUpdate",
    value: function handleExternalCartUpdate(event) {
      this.log('Handling external cart update');
      this.cartData = event.detail.cartData;
      this.setInitialState();
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('b2b-subscription-choose', B2BSubscriptionChoose);
})();

/******/ })()
;